var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgApple(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.0998 19.16C19.6898 18.26 19.9098 17.8 20.3598 16.79C17.0398 15.53 16.5098 10.8 19.7898 8.99C18.7898 7.73 17.3798 7 16.0498 7C15.0898 7 14.4298 7.25 13.8398 7.48C13.3398 7.67 12.8898 7.84 12.3298 7.84C11.7298 7.84 11.1998 7.65 10.6398 7.45C10.0398 7.23 9.39983 7 8.59983 7C7.10983 7 5.51983 7.91 4.50983 9.47C3.08983 11.67 3.33983 15.79 5.62983 19.31C6.44983 20.57 7.54984 21.98 8.97984 22C9.57984 22.01 9.96983 21.83 10.3998 21.64C10.8898 21.42 11.4198 21.18 12.3498 21.18C13.2798 21.17 13.7998 21.42 14.2898 21.64C14.7098 21.83 15.0898 22.01 15.6798 22C17.1198 21.98 18.2798 20.42 19.0998 19.16Z",
    fill: "#292D32"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.8404 2C16.0004 3.1 15.5504 4.19 14.9604 4.95C14.3304 5.77 13.2304 6.41 12.1704 6.37C11.9804 5.31 12.4704 4.22 13.0704 3.49C13.7404 2.69 14.8704 2.07 15.8404 2Z",
    fill: "#292D32"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgApple);
export default __webpack_public_path__ + "static/media/apple.42626dc10128538c5f9a1b0054acadde.svg";
export { ForwardRef as ReactComponent };